import { bestsellerIcon, gamelevelIcon, locationIcon, paddlesIcon, settingsIcon } from "@/assets/prompts-icons";
import { isFrance, isPortugal } from './constants';


const getCountryCode = () => {
  const cookie = document.cookie.match(/localization=([^;]+)/);
  if (cookie) {
    return cookie[1];
  }
  return 'GB';
};

const getPrompts = () =>
  [
    {
      caption: 'Recommend product',
      iconSvg: settingsIcon,
      translationId: 'pickleball_recommend_product',
    },
    {
      caption: 'Upgrade paddle',
      iconSvg: paddlesIcon,
      translationId: 'pickleball_paddles',
    },
    // {
    //   caption: 'Best sellers',
    //   iconSvg: bestsellerIcon,
    //   translationId: 'pickleball_best_seller',
    // },
    {
      caption: 'SUMMER SALE',
      iconSvg: bestsellerIcon,
      translationId: 'pickleball_summer_sale',
    },
    {
      caption: 'For a club',
      iconSvg: gamelevelIcon,
      translationId: 'pickleball_game_level',
    },
    {
      caption: 'Track order',
      iconSvg: locationIcon,
      translationId: 'pickleball_court_near_me',
    },
  ].filter(Boolean);

const getAPIKey = () => {
  // France
  if (isFrance) {
    return 'cGlja2xlYmFsbF9mcjpza19saXZlX05BMG5leHZHdmhzaDZPS2Zoa2xYc3psVVltdWV6ZUI3NHoxU1dtSnp2a2JyNkVyNlhMcGpZandCMUUyS3dnWEVjMXoxdWVkU2xxakNsWVF6TkZKVVJFWk4xakN1R25SY1RQck5uSzR6MUl5d25acVNqS0JVYWtUb09IQXNaQ3ZsWktIZE1IVXBHUm9wS0Yyc0ZrelpQU25wUUpMTUNIekFHMHRCUjlrVXZB';
  }
  // Portugal
  if (isPortugal) {
    return 'cGlja2xlYmFsbF9wdDpza19saXZlX3RzQnpEMWtUZmdMd3l2elgzTHc1SFdzT0F0WTNnSzNLc1p2SWNsc2JqWWhsYWJZVnlrSFRWakxHQWF3S05ublhSYUhMelVrNDB4Q1ZFd1d6Qnc5UnNjT0kzWHFvQkRYUVZhdXlNR3paT1hzc1FrTVJHaWdud0U2R2NqZjNTa2xrcGR1RFROdFl4dEJQQ2NNdUZpdEdUUFdDTjRhRE1Na0pQQ0dPTFB6bWhO';
  }
  // GB or local env
  return 'cGlja2xlYmFsbDpza19saXZlX0hmcU1JMklBWFVvaDNZZjFpaXhzVHJ3MndGZXJUbm92OHZzUWxQV3Y5eHY2QmttdDBMaDdQTXA5cnpnM2VlNlczdjlaYzFPNVE4NUVzTUJMcnFkSUVUekoyNmd4MkxnRnY5azBRbWVVQnpKTkEzM2NrYU51YVA1c1RSdXNPSWxOcHgyeW1wMkhIa1JPdEpsQjFsQ2VxMHNrT01TbmlPaVRWd2YyVlVkS2dS';
}

export const config = {
  projectName: 'PICKLEBALL',
  apiKey: getAPIKey(),
  apiUrl: 'https://saywhatt-frj5cmaowa-uk.a.run.app',
  localization: window.sayWhattChat.getLocale(),
  countryCode: getCountryCode(),
  prompts: getPrompts(),
  productCard: {
    relativeLinks: true,
    variantsConfig: {
      color: {
        optionNames: ['color', 'colour'],
        replaceName: 'color',
      },
      button: {
        optionNames: ['version', 'Choose Variation', 'core', 'variant', 'Core Thickness'],
        replaceName: 'size',
      },
      dropdown: {
        optionNames: ['size'],
      },
    },
  },
  theme: {
    colors: {
      light: '#BAFFCD',
      dark: '#2C8946',
    },
    container: {
      mobile: {
        height: 'calc(100% - 40px)',
      },
    },
    messageText: {
      user: {
        color: '#000 !important',
      },
    },
    prompts: {
      desktop: {
        justifyContent: 'center',
        marginLeft: '-10px',
        marginRight: '-10px',
      },
      mobile: {
        justifyContent: 'center',
        marginLeft: '-15px',
        marginRight: '-15px',
      },
      item: {
        styles: {
          flex: '0 0 auto',
          img: {
            maxHeight: '16px',
          },
        },
        desktop: {
          padding: '7px 6px',
          '& img': {
            marginRight: '3px',
          },
        },
        mobile: {
          fontSize: '11px',
          padding: '7px 8px',
          '& img': {
            marginRight: '2px',
            width: '13px',
          },
        },
      },
    },
    embeddedPage: {
      global: {
        '#saywhatt-page': {
          marginTop: '-40px',
          marginBottom: '-52px',
          height: 'calc(100dvh - 169px)',
          '@media (max-width: 768px)': {
            height: 'calc(100dvh - 120px)',
          },
        },
        '.needsclick': {
          display: 'none !important',
        },
      },
      welcomeScreen: {
        mobile: {
          padding: '0',
        },
      },
      prompts: {
        mobile: {
          marginLeft: '-15px',
          marginRight: '-15px',
        },
      },
    },
  },
};
